















































import { createComponent, ref, inject } from "@vue/composition-api";
import {
  asortymentResource,
  Asortyment,
} from "@megarax/client/src/resources/plm/Asortyment";
import {
  sheetOptionsSymbol,
  SheetHighlights,
} from "@/components/sheet/SheetEntries";
import { VueConstructor } from "vue";
import BaseDialog from "./BaseDialog.vue";
import BaseButton from "./BaseButton.vue";

interface Props<TUnit> {
  value: TUnit[];
  editable: boolean;
  unitFactory: () => TUnit;
  unitIsEqual: (a: TUnit, b: TUnit) => boolean;
  unitFormComponent: VueConstructor;
}

export default createComponent<Props<any>>({
  components: { BaseDialog, BaseButton },
  props: {
    value: { required: true },
    editable: { type: Boolean, default: false },
    unitFactory: { required: true },
    unitIsEqual: { type: Function, default: () => false },
    unitFormComponent: { required: true },
  },
  setup(props, ctx) {
    const newUnit = ref<any>(null);
    const newUnitForm = ref<any>(null);

    function openNewItemDialog() {
      newUnit.value = props.unitFactory();
    }

    async function addNewUnit() {
      await newUnitForm.value!.validate();

      if (
        props.value.filter((unit) => props.unitIsEqual(unit, newUnit.value))
          .length != 0
      ) {
        ctx.root.$notify.warning("Ten element jest już na liście.");
        return;
      }

      props.value.push(newUnit.value);
      newUnit.value = null;
    }

    function deleteUnit(unit: any) {
      const index = props.value.indexOf(unit);
      props.value.splice(index, 1);
    }

    return {
      addNewUnit,
      asortymentResource,
      deleteUnit,
      newUnit,
      newUnitForm,
      openNewItemDialog,
    };
  },
});
